import './Text.css';
import React, { useState } from 'react';

export function AHole() {
const [vokEOYrj_EA] = useState('vokEOYrj_EA')
  return (
    <div class="body">
      <div class="row" >


<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${vokEOYrj_EA}?autoplay=0`}>
</iframe>

      
      </div>
    
    </div>

  );
}
